import { User } from '@interfaces/user.interface'
import { BehaviorSubject } from 'rxjs'
export default new BehaviorSubject<User | null>(null)
